import { Link } from 'react-router-dom';

export default function TermsOfUse() {
    const year = new Date().getFullYear();

    return (
        <main className="min-h-screen bg-brand-bg text-white">
            <header className="border-b border-white/10 bg-[#0B0E14CC] backdrop-blur supports-[backdrop-filter]:bg-[#0B0E14CC]">
                <div className="mx-auto max-w-4xl px-6 py-4 flex items-center justify-between">
                    <h1 className="text-lg font-semibold">Termos de Uso</h1>
                    <Link className="text-sm text-brand-muted hover:text-white transition" to="/">
                        Voltar
                    </Link>
                </div>
            </header>

            <section className="mx-auto max-w-4xl px-6 py-10">
                <p className="text-sm text-brand-muted">
                    Última atualização: {new Date().toLocaleDateString('pt-BR')}
                </p>

                <div className="mt-6 space-y-6 text-brand-muted leading-relaxed">
                    <p>
                        Estes Termos de Uso regulam o acesso e a utilização deste site (“Site”). Ao navegar no Site, você concorda com estes termos.
                    </p>

                    <div>
                        <h2 className="text-white font-semibold">1. Uso do Site</h2>
                        <p className="mt-2">
                            Você se compromete a utilizar o Site de forma lícita, respeitando a legislação aplicável, a boa-fé e os direitos de terceiros.
                        </p>
                    </div>

                    <div>
                        <h2 className="text-white font-semibold">2. Conteúdo e propriedade intelectual</h2>
                        <p className="mt-2">
                            Textos, marcas, logotipos e demais elementos do Site podem ser protegidos por direitos de propriedade intelectual. É proibida a reprodução sem autorização.
                        </p>
                    </div>

                    <div>
                        <h2 className="text-white font-semibold">3. Contato</h2>
                        <p className="mt-2">
                            Para dúvidas sobre estes termos, entre em contato pelos canais informados no Site.
                        </p>
                    </div>

                    <p className="text-xs">© {year} Antares Tecnologia. Todos os direitos reservados.</p>
                </div>
            </section>
        </main>
    );
}

export { };

